import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import { v4 } from 'uuid'

class JitsuBar extends Component {
  constructor() {
    super();
    this.state = {

    }
  }

  pressEnter = (event) => {

    if (event.keyCode == 13) {

    }

  }

  onJitsuBarClick = () => {

    // window.location.hash = "jitsu-bar-options"
    window.location.hash = 'jitsu-camponent'

  }

  render() {

    return (
      <div onClick={ (event) => {
                 this.onJitsuBarClick()
               } } style={ { backgroundColor: "grey" } } className="w-100 d-flex justify-content-around align-items-center p-1">
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/star.png` } />
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/sabers.svg` } />
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/star.png` } />
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/sabers.svg` } />
        <span className="animated pulse" style={ { fontSize: "2vh", color: "white", fontFamily: " 'Gloria Hallelujah', cursive" } }>jitsu bar</span>
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/sabers.svg` } />
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/star.png` } />
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/sabers.svg` } />
        <img style={ { height: '2vh' } } className={ `animated  rotateIn` } src={ `./images/star.png` } />
      </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  messaginScreen: state.messaginScreen

})

export default connect(mapStateToProps, {

})(JitsuBar)


// WEBPACK FOOTER //
// ./src/Components/JitsuBarOptions/jitsuBar.js